<template>
  <div class="hwh-calculator-stepper">
    <div class="hwh-calculator-stepper__inner">
      <div v-for="(step, key) in steps"
           :key="key"
           class="hwh-calculator-stepper__item"
           :class="{'hwh-calculator-stepper__item--active': currentStep === step.id, 'hwh-calculator-stepper__item--disabled': !isValid}"
           @click="changeStep(step.id)">
        {{ step.label }}
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config';

export default {
  name: 'Stepper',
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
    isValid: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      steps: config.STEPS,
    };
  },
  methods: {
    changeStep(step) {
      this.$emit('changeStep', step);
    },
  },
};
</script>
